import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';

import SingleScreenWrapper from './SingleScreenWrapper';

class SingleScreenWrapperContainer extends React.Component {
  render() {
    const {
      autoLayoutStateId,
      config,
      configStateId,
      contextParams,
      metadata,
      screenId,
      screenStyles,
    } = this.props;
    return (
      <SingleScreenWrapper
        autoLayoutStateId={autoLayoutStateId}
        config={config}
        configStateId={configStateId}
        contextParams={contextParams}
        metadata={metadata}
        itemContent={metadata.getItemContent()}
        itemLayout={metadata.getItemLayout()}
        screenId={screenId}
        screenStyles={screenStyles}
      />
    );
  }
}

SingleScreenWrapperContainer.displayName = 'SingleScreenWrapperContainer';

SingleScreenWrapperContainer.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  configStateId: PropTypes.string.isRequired,
  contextParams: PropTypes.objectOf(PropTypes.any).isRequired,
  metadata: PropTypes.objectOf(PropTypes.any).isRequired,
  screenId: PropTypes.string.isRequired,
  screenStyles: PropTypes.objectOf(PropTypes.any),
};

SingleScreenWrapperContainer.defaultProps = {
  screenStyles: undefined,
};

export default connect()(SingleScreenWrapperContainer);
